<template>
  <div class="product-container">
    <Bread metertype="智能供电"></Bread>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
</style>
